/*
 * ТЗ BM v2 §7: ответ 422 подсвечивает конкретные поля формы правила, а не
 * прячется за общим текстом.
 *
 * FastAPI отдаёт detail массивом { loc, msg }: loc — путь до поля в теле
 * запроса (['body', 'threshold']). Английский msg
 * пользователю не показывается (STYLE_GUIDE): у поля появляется понятный
 * русский текст, а русский msg backend выводится как есть.
 */

const FORM_FIELDS = {
  name: 'name',
  camera_id: 'camera',
  zone_id: 'zone',
  zone_ids: 'zone',
  zone_scope: 'zone',
  metric: 'metric',
  operator: 'operator',
  threshold: 'threshold',
  duration_seconds: 'duration',
  allowed_gap_seconds: 'gap',
  cooldown_enabled: 'cooldown',
  cooldown_value: 'cooldown',
  cooldown_unit: 'cooldown',
  category: 'category',
};

const DEFAULT_FIELD_MESSAGE = 'Проверьте значение';

const userMessage = (msg) => (
  typeof msg === 'string' && /[А-Яа-яЁё]/.test(msg) && !/[A-Za-z0-9]+_[A-Za-z0-9_]+/.test(msg)
    ? msg
    : DEFAULT_FIELD_MESSAGE
);

/**
 * { form, matched } — ошибки полей формы.
 * matched = false: 422 не про поля формы (или не 422) — вызывающий показывает
 * общий текст.
 */
export const ruleFieldErrorsFrom422 = (error) => {
  const result = { form: {}, matched: false };
  if (error?.response?.status !== 422) return result;
  const detail = error.response.data?.detail;
  if (!Array.isArray(detail)) return result;

  detail.forEach((item) => {
    const loc = Array.isArray(item?.loc) ? item.loc.filter((part) => part !== 'body') : [];
    const message = userMessage(item?.msg);
    const key = FORM_FIELDS[loc[0]];
    if (key) {
      if (!result.form[key]) result.form[key] = message;
      result.matched = true;
    }
  });
  return result;
};
